import { Text } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const Title = styled(Text)`
  p {
    font-size: 28px;
  }
`
